import React, { FC, useEffect, useRef } from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import { TweenMax } from 'gsap';
import styles from './styles';

interface Props {
  classes: any;
  text: string | JSX.Element;
}

const SubmissionErrorMessage: FC<Props> = (props: Props) => {
  const { classes, text } = props;
  const messageRef = useRef();

  useEffect(() => {
    if (messageRef.current) {
      TweenMax.to(messageRef.current, 0.5, { opacity: 1 });
    }
  }, []);

  return (
    <div
      ref={messageRef}
      className={classNames(classes.submissionError)}
      data-testid="submission-error-message"
    >
      <span className={classNames(classes.text)}>{text}</span>
    </div>
  );
};

export default injectSheet(styles)(SubmissionErrorMessage);
